import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from './Home';
//import TopMenu from './TopMenu.js';
import { TopMenu, TopMenuDesktop } from './topMenu.js';
import MobileSync from './MobileSync.js';
import EntryInputForm from "./entryInputForm";
import DesktopSync from "./DesktopSync";
import About from './About.js';
import GoogleAnalytics from "react-ga";

GoogleAnalytics.initialize("UA-84319750-4");

function App() {
  return (
    <Router basename="/mobile">
      <div style={{ marginBottom: '5em' }}>
      <Switch>
          <Route exact path="/desktop" component={MenuDesktop} />
          <Route component={Menu} />
      </Switch>
        <Route exact path="/" component={ShowHome} />
        <Route path="/add" component={Add} />
        <Route path="/about" component={ShowAbout} />
        <Route path="/sync" component={Sync} />
        <Route path="/desktop" component={Desktop} />
      </div>
    </Router>
  );
}

function MenuDesktop(){
  return(
    <div>
    </div>
  )
}
function Menu(){
  return(
    <TopMenu />
  )
}
function ShowHome() {
  GoogleAnalytics.pageview("Home");
  return (
    <Home />
  );
}

function ShowAbout() {
  GoogleAnalytics.pageview("About");
  return (
    <About></About>
  );
}
function Add() {
  GoogleAnalytics.pageview("Add");
  return (
      <EntryInputForm />
  );
}
function Sync() {
  GoogleAnalytics.pageview("Sync");
  return (
      <MobileSync />
  );
}
function Desktop() {
  GoogleAnalytics.pageview("Desktop");
  return (
      <DesktopSync></DesktopSync>
  );
}

export default App;
